import { useState, useEffect } from 'react';
import { Users, Eye, X, Mail, Phone, MapPin, Clock, CheckCircle } from 'lucide-react';

export default function SolicitudesAdmin() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => { cargarSolicitudes(); }, []);

  const cargarSolicitudes = async () => {
    try {
      const res = await fetch('https://logia-production-725b.up.railway.app/api/admin/solicitudes');
      const data = await res.json();
      if (data.success) setSolicitudes(data.data);
    } catch (error) { console.error("Error:", error); }
  };

  const abrirModal = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setIsModalOpen(true);
  };

  const actualizarEstado = async (id, nuevoEstado) => {
    try {
      const res = await fetch(`https://logia-production-725b.up.railway.app/api/admin/solicitudes/${id}/estado`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: nuevoEstado })
      });
      const data = await res.json();
      if (data.success) {
        cargarSolicitudes();
        if (solicitudSeleccionada) {
          setSolicitudSeleccionada({ ...solicitudSeleccionada, estado: nuevoEstado });
        }
      } else alert('Error al actualizar: ' + data.error);
    } catch (error) { alert('Error de conexión.'); }
  };

  const getStatusBadge = (estado) => {
    const badges = {
      'pendiente': 'bg-yellow-900/30 text-yellow-500 border-yellow-700/50',
      'contactado': 'bg-blue-900/30 text-blue-400 border-blue-700/50',
      'aceptado': 'bg-green-900/30 text-green-400 border-green-700/50',
      'rechazado': 'bg-red-900/30 text-red-400 border-red-700/50'
    };
    return <span className={`px-2 py-1 text-[10px] uppercase tracking-widest font-mono border rounded-sm ${badges[estado] || badges['pendiente']}`}>{estado}</span>;
  };

  return (
    <div className="flex flex-col gap-6 animate-fade-in relative">
      <div className="flex justify-between items-center bg-[#0a0a0a] border border-white/10 p-6 shadow-lg relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 mix-blend-overlay pointer-events-none"></div>
        <div className="relative z-10">
          <h1 className="font-serif text-3xl md:text-4xl text-[#C5A059] m-0 tracking-wide flex items-center gap-3">
            <Users size={32} /> CRM de Postulantes
          </h1>
          <p className="text-gray-400 font-light text-sm mt-2 m-0">Gestiona las solicitudes de ingreso a la Orden.</p>
        </div>
      </div>

      <div className="overflow-x-auto bg-[#050505] border border-white/5">
        <table className="w-full text-left border-collapse min-w-[800px]">
          <thead>
            <tr className="border-b border-white/10 bg-white/5">
              <th className="py-4 px-6 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase font-semibold">Fecha</th>
              <th className="py-4 px-6 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase font-semibold">Postulante</th>
              <th className="py-4 px-6 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase font-semibold">Ciudad</th>
              <th className="py-4 px-6 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase font-semibold">Estado</th>
              <th className="py-4 px-6 text-[#C5A059] text-[10px] tracking-[0.2em] uppercase font-semibold text-right">Acción</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.map((sol) => (
              <tr key={sol.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                <td className="py-4 px-6 text-gray-400 text-xs font-mono">{new Date(sol.fecha_solicitud).toLocaleDateString()}</td>
                <td className="py-4 px-6">
                  <p className="text-white text-sm font-medium m-0">{sol.nombres} {sol.apellidos}</p>
                  <p className="text-gray-500 text-xs m-0">{sol.email}</p>
                </td>
                <td className="py-4 px-6 text-gray-300 text-sm">{sol.ciudad}</td>
                <td className="py-4 px-6">{getStatusBadge(sol.estado)}</td>
                <td className="py-4 px-6 text-right">
                  <button onClick={() => abrirModal(sol)} className="text-[#C5A059] hover:text-white transition-colors p-2 text-xs flex items-center gap-2 ml-auto uppercase tracking-widest">
                    <Eye size={16} /> Revisar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && solicitudSeleccionada && (
        <div className="fixed inset-0 z-[999] flex justify-center items-start px-4 sm:px-6 bg-[#050505]/90 backdrop-blur-sm">
          <div className="bg-[#0a0a0a] border border-[#C5A059]/30 w-full max-w-xl shadow-2xl relative animate-fade-in">
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C5A059] to-transparent opacity-50"></div>
            
            <div className="flex justify-between items-center p-6 border-b border-white/10">
              <div>
                <h2 className="font-serif text-2xl text-white m-0">Detalle de Solicitud</h2>
                <div className="mt-2">{getStatusBadge(solicitudSeleccionada.estado)}</div>
              </div>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-white"><X size={24} /></button>
            </div>
            
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-[#050505] p-4 border border-white/5">
                  <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Nombre Completo</p>
                  <p className="text-white text-sm">{solicitudSeleccionada.nombres} {solicitudSeleccionada.apellidos}</p>
                </div>
                <div className="bg-[#050505] p-4 border border-white/5 flex items-center gap-3">
                  <MapPin className="text-[#C5A059]" size={18} />
                  <div>
                    <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Ciudad</p>
                    <p className="text-white text-sm">{solicitudSeleccionada.ciudad}</p>
                  </div>
                </div>
              </div>

              <div className="bg-[#050505] p-4 border border-white/5 space-y-3">
                <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-2">Datos de Contacto</p>
                <div className="flex items-center gap-3">
                  <Mail className="text-[#C5A059]" size={16} />
                  <a href={`mailto:${solicitudSeleccionada.email}`} className="text-gray-300 text-sm hover:text-white">{solicitudSeleccionada.email}</a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="text-[#C5A059]" size={16} />
                  <a href={`https://wa.me/${solicitudSeleccionada.telefono.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" className="text-gray-300 text-sm hover:text-white">{solicitudSeleccionada.telefono}</a>
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-4">Actualizar Estado</p>
                <div className="flex flex-wrap gap-3">
                  <button onClick={() => actualizarEstado(solicitudSeleccionada.id, 'contactado')} className="flex-1 py-2 text-xs uppercase tracking-widest border border-blue-900 text-blue-400 hover:bg-blue-900/30 transition">Contactado</button>
                  <button onClick={() => actualizarEstado(solicitudSeleccionada.id, 'aceptado')} className="flex-1 py-2 text-xs uppercase tracking-widest border border-green-900 text-green-400 hover:bg-green-900/30 transition">Aceptado</button>
                  <button onClick={() => actualizarEstado(solicitudSeleccionada.id, 'rechazado')} className="flex-1 py-2 text-xs uppercase tracking-widest border border-red-900 text-red-400 hover:bg-red-900/30 transition">Rechazado</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}